"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const RawQueryError_1 = tslib_1.__importDefault(require("./errors/RawQueryError"));
const RawQuery_1 = tslib_1.__importDefault(require("./queries/RawQuery"));
const handleResponse_1 = tslib_1.__importDefault(require("./utils/handleResponse"));
const getFetch = () => {
    if (window && window.fetch) {
        return window.fetch;
        /* tslint:disable */
        // @ts-ignore We attach fetch to global
    }
    else if (global && global.fetch) {
        // @ts-ignore We attach fetch to global
        return global.fetch;
        /* tslint:enable */
    }
    else {
        console.log("Unable to aquire fetch from window or global");
        throw new Error("No fetch implementation available");
    }
};
async function fetchRawQuery(request, { ctrl, handlers = {} }) {
    let response;
    ctrl.startTimeout();
    try {
        response = await getFetch()(request, { signal: ctrl.signal });
    }
    catch (error) {
        ctrl.cancelTimeout();
        if (error.name === "AbortError" && ctrl.hasTimedOut) {
            /* The request has timed out */
            throw new RawQueryError_1.default("Request timeout", request, ctrl, null, error);
        }
        throw new RawQueryError_1.default(error.message, request, ctrl, null, error);
    }
    finally {
        ctrl.cancelTimeout();
    }
    return (0, handleResponse_1.default)(new RawQuery_1.default(request, response, ctrl), handlers);
}
exports.default = fetchRawQuery;
